"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactHero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const headlineRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion || !headlineRef.current) return;
    const pulse = () => {
      if (!headlineRef.current) return;
      headlineRef.current.style.transform = "scale(1.03)";
      setTimeout(() => {
        if (!headlineRef.current) return;
        headlineRef.current.style.transform = "scale(1)";
      }, 400);
    };
    const interval = setInterval(pulse, 8000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-light-background via-light-background to-muted-light-background">
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503393/img/contact_hero_study_scene.png)",
      transform: "translateZ(0)",
      willChange: "transform"
    }} />

      <div className="absolute inset-0 bg-gradient-to-t from-light-background/80 via-transparent to-light-background/60" />

      <div ref={contentRef} className={`relative z-10 max-w-4xl mx-auto px-6 py-12 text-center transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 ref={headlineRef} className="text-5xl md:text-6xl lg:text-7xl font-display font-bold text-foreground mb-6 transition-transform duration-300 ease-out" style={{
        willChange: "transform"
      }}>Contact us</h1>

        <p className="text-2xl md:text-3xl text-primary font-semibold mb-4">Thinking of starting Your Child's Journey to Success?</p>

        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">Book a free 15 min consultation to discuss how Education Family Tutors can help your child build confidence, improve grades, and develop essential skills for lifelong learning.&nbsp; If you only want to enquire or need a few questions answered, then please fill out the contact form and we will get back to you as soon as possible.</p>

        <Button asChild size="lg" className="btn-primary text-lg px-8 py-4 shadow-medium hover:shadow-strong hover:-translate-y-1 active:translate-y-0 transition-all duration-[var(--duration-medium)]">
          <Link to="#contact-form">Get in touch or Schedule a Call below</Link>
        </Button>
      </div>
    </section>;
}